import './App.css';
import './assets/css/style.css';
import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from './pages/Home';
import LogIn from './pages/LogIn';
import PrivateRoute from "./components/PrivateRoute";
import Register from './pages/Register';
import UserSettings from './pages/UserSettings';
import ThemeSelector from './pages/ThemeSelector';
import Stats from './pages/Stats';
import AutoTest from './pages/AutoTest';
import Eval from './pages/Eval';
import FillTheGap from './pages/FillTheGap';
import MixedWords from './pages/MixedWords';
import MixedWordsV1 from './pages/MixedWords-v1';
import WordMatch from './pages/WordMatch';
import WordMatchV1 from './pages/WordMatch-v1';
import ArrowsQCM from './pages/ArrowsQCM';
import VinyleQCM from './pages/VinyleQCM';
import UserManagement from "./pages/UserManagementPage";

function App() {
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = location.pathname === "/" ? "visible" : "hidden";

    return () => {
      document.body.style.overflow = "visible";
    };
  }, [location]);

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <LogIn />
            </motion.div>} />
          <Route path="/register" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <Register />
            </motion.div>} />
          <Route path="/userSettings" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <UserSettings />
            </motion.div>} />
          <Route
            path="/themeSelector"
            element={
              <PrivateRoute>
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ duration: 0.3 }}
                >
                  <ThemeSelector />
                </motion.div>
              </PrivateRoute>
            }
          />
          <Route path="/stats" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <Stats />
            </motion.div>} />
          <Route path="/autoTest" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <AutoTest />
            </motion.div>} />
          <Route path="/eval" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <Eval />
            </motion.div>} />
          <Route path="/fillthegap" element={
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.3 }}
            >
              <FillTheGap />
            </motion.div>
          } />
            <Route path="/settings/users" element={<UserManagement />} />

          <Route path="/mixedwords" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <MixedWords />
            </motion.div>
          } />
          <Route path="/mixedwordsv1" element={<MixedWordsV1 />} />
          <Route path="/wordmatch" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <WordMatch />
            </motion.div>} />
          <Route path="/wordmatchV1" element={<WordMatchV1 />} />
          <Route path="/vinyleQCM" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <VinyleQCM />
            </motion.div>} />
          <Route path="/arrowsQCM" element={
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <ArrowsQCM />
            </motion.div>} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
